import React, { useEffect, useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { Trans, withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom"; // Import withRouter
import axios from "axios";

const MatchPopup = ({ history, openModal, user, friend, getdata }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (openModal) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [openModal]);

  const closeModal = () => {
    getdata();
    setOpen(false);
  };

  const startMessage = () => {
    const api_url = localStorage.getItem("api_url");
    const lang = localStorage.getItem("LangValue");
    const formdata = new FormData();
    formdata.set("receiver_id", user.user_id);
    formdata.set("sender_id", friend.user_id);
    formdata.set("language", lang);

    axios({
      method: "post",
      url: api_url + "webcreatchat",
      data: formdata,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      const chatid = res.data.chatid;
      history.push(`/app/Message/MessageNew/${friend.user_id}/${chatid}`); // Use history.push here
    });
  };

  return (
    <Modal
      isOpen={open}
      toggle={closeModal}
      className="premiumPopup matchPopup vertically-center apd5"
    >
      <ModalHeader toggle={closeModal}></ModalHeader>
      <ModalBody>
        <div className="modal-images media">
          <div className="matchmedia">
            <img src={user && user.user_image} alt="" className="" />
          </div>
          <div className="matchlike"></div>
          <div className="matchmedia">
            <img
              src={
                friend && friend.profile_image
                  ? `https://services.hitasoft.in/braxelet/uploads/user/${friend.profile_image}`
                  : "https://services.hitasoft.in/braxelet/uploads/user/default_user.png"
              }
              alt=""
              className=""
            />
          </div>
        </div>

        <div className="justify-content-end text-center matchContent">
          <Trans i18nKey="It's a Match!">It's a Match!</Trans>
        </div>
        <div className="justify-content-end text-center matchContentSub">
          You and {friend && friend.name} like each other
        </div>
        <div className="justify-content-end text-center">
          <button
            className="bg-white pink-color matchButton"
            onClick={startMessage}
          >
            <Trans i18nKey="Send message">Send message</Trans>
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default withRouter(MatchPopup); // Ensure withRouter is correctly applied
